export const FeatureFlag = {
    FADE_OUT_MICRO_PAYMENT : true,
    FADE_OUT_MICRO_PAYMENT_2 : true,
    FADE_OUT_APPTECH : true,
    FADE_OUT_1: true, // FO 2차: 10/20
    FADE_OUT_2: true, // FO 3차: 10/27
    FADE_OUT_3: true, // FO 4차: 11/03
    //RESUME_RELOAD_TIME: 0, // 리로드 비활성
    //RESUME_RELOAD_TIME: 1 * (60 * 1000), // 분
    RESUME_RELOAD_TIME: 2 * (60 * 60 * 1000), // 시간
    //RESUME_RELOAD_TIME: 1 * (24 * 60 * 60 * 1000), // 일
}
